import hero from "@/assets/hero-athlete.png";
import { useSiteContent } from "@/hooks/useSiteContent";

const Hero = () => {
  const { t } = useSiteContent();
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="container grid lg:grid-cols-12 gap-8 pt-12 pb-20 lg:pt-20 lg:pb-32">
        <div className="lg:col-span-7 flex flex-col justify-center animate-float-up">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-6">
            <span className="w-8 h-px bg-primary" /> {t("hero.eyebrow", "Issue 01 · Spring")}
          </span>
          <h1 className="text-[clamp(3rem,9vw,8rem)] text-balance">
            {renderHeadline(t("hero.headline_line1", "Know her name."), "primary")}
            <br />
            {renderHeadline(t("hero.headline_line2", "Back her game."), "accent")}
          </h1>
          <p className="mt-8 text-lg md:text-xl text-muted-foreground max-w-xl">
            {t("hero.subheading", "Profiles of the women redefining sport — and the causes and brands they stand behind. Read, give, shop.")}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#athletes"
              className="px-7 py-4 rounded-full bg-secondary text-secondary-foreground font-semibold hover:bg-primary hover:text-primary-foreground transition-all shadow-soft"
            >
              {t("hero.cta_primary", "Meet the athletes →")}
            </a>
            <a
              href="#how-to-back"
              className="px-7 py-4 rounded-full bg-highlight text-highlight-foreground font-semibold hover:bg-accent transition-all"
            >
              {t("hero.cta_secondary", "Back her game")}
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[3/4] rounded-[2rem] overflow-hidden shadow-bold">
            <img
              src={hero}
              alt="Female sprinter in motion"
              width={1536}
              height={1024}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-primary-foreground">
              <p className="text-xs uppercase tracking-[0.2em] opacity-80">{t("hero.cover_label", "Cover athlete")}</p>
              <p className="font-display text-3xl mt-1">{t("hero.cover_name", "Maya Reyes")}</p>
              <p className="serif text-sm mt-1 opacity-90">"{t("hero.cover_quote", "Longevity is the new gold medal.")}"</p>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

// Highlight the last word of a headline line in serif/colored type, matching original look.
const renderHeadline = (text: string, color: "primary" | "accent") => {
  const trimmed = text.replace(/\.+$/, "");
  const period = text.endsWith(".") ? "." : "";
  const parts = trimmed.split(" ");
  if (parts.length < 2) {
    return <span className={`serif font-normal text-${color}`}>{text}</span>;
  }
  const last = parts.pop()!;
  return (
    <>
      {parts.join(" ")} <span className={`serif font-normal text-${color}`}>{last}</span>{period}
    </>
  );
};

export default Hero;
